import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Showcase from "./components/Showcase";
import ReaderPreview from "./components/ReaderPreview";
import Categories from "./components/Categories";
import Faq from "./components/Faq";
import Brand from "./components/Brand";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <Showcase />
        <ReaderPreview />
        <Categories />
        <Faq />
        <Brand />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}